var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n    Dunger Component\n\n    "),_c('ComponentView',{attrs:{"entrypoint":"test","id":"workers"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }